"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _alloyReactTabs = _interopRequireWildcard(require("@adsk/alloy-react-tabs"));

var _alloyReactHelpers = require("@adsk/alloy-react-helpers");

var _DetailsTab = _interopRequireDefault(require("./DetailsTab"));

var _Spacer = _interopRequireDefault(require("../shared/Spacer"));

var _mediaDetailContext = require("./media-detail-context");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Container = _styledComponents.default.div`
  padding: 0 16px;
`;

const MediaDetailDashboard = () => {
  const {
    state: {
      media
    },
    mediaHandlers: {
      renderReferences
    }
  } = (0, _mediaDetailContext.useMedia)();
  const {
    T
  } = (0, _alloyReactHelpers.useLocale)(({
    locale
  }) => require(`../i18n/${locale}.json`));
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 16
  }), /*#__PURE__*/_react.default.createElement(_alloyReactTabs.default, {
    labelWidth: _alloyReactTabs.default.LABEL_WIDTH.FULL
  }, /*#__PURE__*/_react.default.createElement(_alloyReactTabs.Tab, {
    tab: "one",
    label: T.translate("DETAILS")
  }, /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 16
  }), /*#__PURE__*/_react.default.createElement(_DetailsTab.default, null), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 16
  })), renderReferences && /*#__PURE__*/_react.default.createElement(_alloyReactTabs.Tab, {
    tab: "references",
    label: T.translate("REFERENCES")
  }, renderReferences({
    media
  }))), /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    height: 16
  }));
};

var _default = MediaDetailDashboard;
exports.default = _default;